export default __webpack_public_path__ + "f1e79d4.png";